import { useEffect, useMemo, useState } from 'react';

/**
 * 渐进式"加载更多"分页（移动端友好，避免一次性渲染长列表）
 *
 * @param {Array} items 完整数据数组（已过滤）
 * @param {number} pageSize 每批数量
 * @param {string|number} resetKey 筛选条件标识，变化时重置回第一批
 */
const useLoadMore = (items, pageSize = 24, resetKey = '') => {
  const [visibleCount, setVisibleCount] = useState(pageSize);

  useEffect(() => {
    setVisibleCount(pageSize);
  }, [pageSize, resetKey]);

  const visibleItems = useMemo(
    () => (Array.isArray(items) ? items.slice(0, visibleCount) : []),
    [items, visibleCount]
  );

  const total = Array.isArray(items) ? items.length : 0;

  return {
    visibleItems,
    hasMore: visibleCount < total,
    remaining: Math.max(total - visibleCount, 0),
    loadMore: () => setVisibleCount((prev) => prev + pageSize),
  };
};

export default useLoadMore;
